
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/pdp",
      function () {
        return require("private-next-pages/products/pdp.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/pdp"])
      });
    }
  